(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.dataset.zjMotion === 'false';
  function setup(root = document) {
    root.querySelectorAll('[data-zj-benefits]:not([data-ready])').forEach(area => {
      area.dataset.ready = 'true';
      const tabs = [...area.querySelectorAll('[data-zj-tab]')];
      function activate(tab) {
        tabs.forEach(button => {
          const active = button === tab;
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
          area.querySelector('#' + CSS.escape(button.getAttribute('aria-controls'))).hidden = !active;
        });
      }
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => {
          let n;
          if (event.key === 'ArrowRight') n = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') n = (i + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') n = 0;
          if (event.key === 'End') n = tabs.length - 1;
          if (n !== undefined) { event.preventDefault(); tabs[n].focus(); activate(tabs[n]); }
        });
      });
    });
    root.querySelectorAll('[data-zj-open-dialog]:not([data-ready])').forEach(button => {
      button.dataset.ready = 'true';
      const dialog = document.getElementById(button.dataset.zjOpenDialog);
      if (!dialog) return;
      button.addEventListener('click', () => dialog.showModal());
      dialog.querySelector('[data-zj-close-dialog]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        const r = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) dialog.close();
      });
    });
    root.querySelectorAll('[data-zj-film]:not([data-ready])').forEach(frame => {
      frame.dataset.ready = 'true';
      const film = frame.querySelector('video'), pause = frame.querySelector('[data-zj-pause]'), sound = frame.querySelector('[data-zj-sound]');
      if (!film) { pause.hidden = sound.hidden = true; return; }
      const sync = () => { pause.textContent = film.paused ? frame.dataset.play : frame.dataset.pause; };
      pause.addEventListener('click', () => { if (film.paused) film.play().catch(sync); else film.pause(); sync(); });
      film.addEventListener('play', sync); film.addEventListener('pause', sync);
      sound.addEventListener('click', () => {
        film.muted = !film.muted;
        sound.textContent = film.muted ? frame.dataset.soundOn : frame.dataset.soundOff;
        sound.setAttribute('aria-pressed', String(!film.muted));
      });
      if (reduced) { film.autoplay = false; film.pause(); sync(); }
    });
    root.querySelectorAll('[data-zj-commerce]:not([data-ready])').forEach(box => {
      box.dataset.ready = 'true';
      const select = box.querySelector('[data-zj-variant]');
      select?.addEventListener('change', () => {
        const chosen = select.selectedOptions[0], available = chosen.dataset.available === 'true';
        box.querySelector('[data-zj-price]').textContent = chosen.dataset.price;
        const button = box.querySelector('[data-zj-add]');
        button.disabled = !available; button.textContent = available ? box.dataset.addLabel : box.dataset.soldLabel;
      });
    });
    if (!reduced && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.animate([{transform: 'translateY(12px)'}, {transform: 'translateY(0)'}], {duration: 500, easing: 'ease-out'});
          observer.unobserve(entry.target);
        }
      }), {threshold: .08});
      root.querySelectorAll('.zj-reveal:not([data-motion-ready])').forEach(el => { el.dataset.motionReady = 'true'; observer.observe(el); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup()); else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:block:select', event => {
    const tab = event.target.matches('[data-zj-tab]') ? event.target : event.target.querySelector('[data-zj-tab]');
    tab?.click();
    event.target.closest('details')?.setAttribute('open', '');
  });
  document.addEventListener('cart:update', () => {
    fetch((window.Shopify?.routes?.root || '/') + 'cart.js').then(r => r.json()).then(cart => {
      document.querySelectorAll('[data-zj-cart-count]').forEach(el => el.textContent = '(' + cart.item_count + ')');
    }).catch(() => {});
  });
})();
